export function generateStarRating(el:any,rating:any){
    let starRating;
    let max_stars = 5;
    let starArray:any = [];

    if(rating=='overrallrating'){
        if(el['overallRating'].toString().indexOf('.') === -1){
            starRating = `${el['overallRating']}.0`
        }else{
            starRating = el['overallRating'].toLocaleString();
        }
    }else{
        if(el['reviewStarRating'].toString().indexOf('.') === -1){
            starRating = `${el['reviewStarRating']}.0`
        }else{
            starRating = el['reviewStarRating'].toLocaleString();
        }
    }
    
    let star_rate:any = Number.isInteger(starRating) ? 1 : 0;
    let starCount= starRating.split('.')
    for (let i = 1; i <= max_stars; i++){
        if(starCount[0] < i && !star_rate){
            star_rate = true;
            starArray.push(spanRating(starCount[1],'star',''));
        }else if(starCount[0] >= i){
            starArray.push(spanRating('','star','on'));
        }else{
            starArray.push(spanRating('','star',''));
        }
    }
    return starArray.join('');
}
function spanRating(partial:any,star:any,on:any){
    let dataPartial = partial ? `data-partial= "${partial}"` : ''; 
    return `<span class="${star} ${on}" ${dataPartial}> ★ </span>`
}